export default {
	init: false,
	vehicles: [],
	history: null,
	importNotification: null,
	importProgress: null,
};
